import React from "react";
import { Modal } from "antd";
import { RxCross2 } from "react-icons/rx";

const ConfirmSuspendModal = ({
  onConfirm,
  onCancel,
  visible,
  entityName = "Remixer",
}) => {
  return (
    <Modal
      open={visible}
      footer={null}
      closable={false}
      centered
      className="custom-dark-confirm-modal"
    >
      <div className="relative px-6 pt-6 pb-4">
        <button
          onClick={onCancel}
          className="absolute right-[10px] top-[10px] w-[20px] h-[20px] text-[#8D8D8D] hover:text-white"
        >
          <RxCross2 size={18} />
        </button>

        <h2 className="text-center text-[18px] font-[600] text-white font-['Public Sans'] leading-[22px]">
          Confirm Suspend
        </h2>

        <div className="mt-[12px] flex flex-col items-center">
          <p className="text-[15px] font-[400] text-[#969696] leading-[22px] text-center font-['Public Sans']">
            Are you sure you want to suspend this {entityName}
          </p>
          <p className="text-[15px] font-[400] text-[#969696] leading-[22px] text-center font-['Public Sans'] mt-1">
            They will lose access immediately
          </p>
        </div>

        <div className="flex justify-center gap-4 mt-[24px]">
          <button
            onClick={onCancel}
            className="flex items-center justify-center px-[15px] py-[2px] border border-[#878787] rounded-[15px] w-[80px] h-[28px]"
          >
            <span className="text-[#878787] text-[12px] font-[400] font-['Inter']">
              Cancel
            </span>
          </button>

          <button
            onClick={onConfirm}
            className="flex items-center justify-center px-[12px] py-[2px] border border-[#DC6700] rounded-[15px] w-[96px] h-[28px] gap-1"
          >
            <span className="text-[#DC6700] text-[18px] font-[400]">⚠</span>
            <span className="text-[#DC6700] text-[12px] font-[400] font-['Inter']">
              Suspend
            </span>
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmSuspendModal;
